import { FormElementModel } from "../../../models/FormElementModel";
import { lengthValidator } from "../../../../utils/formsValidation";
import { t } from "i18next";

export const childRegisterForm = (register: any): FormElementModel[] => [
  {
    name: "name",
    type: "text",
    text: t("imie"),
    isLabel: true,
    register: { ...register("name", { ...lengthValidator(true, 2) }) },
  },
  {
    name: "lastName",
    type: "text",
    text: t("nazwisko"),
    isLabel: true,
    register: { ...register("lastName", { ...lengthValidator(true, 2) }) },
  },
  // {
  //   name: "age",
  //   type: "number",
  //   text: t("wiek"),
  //   isLabel: true,
  //   register: { 
  //     ...register("age", { 
  //       required: t("pole_wymagane"),
  //       min: { value: 1, message: t("wiek_musi_byc_wiekszy_od_0") },
  //       valueAsNumber: true,
  //     }) 
  //   },
  // },
{
  name: "birthDate",
  type: "text",
  text: `${t("data_urodzenia")} (DD.MM.YYYY)`,
  isLabel: true,
  register: {
    ...register("birthDate", {
      required: t("pole_wymagane"),
      onChange: (e: any) => {
        let v = String(e.target.value ?? "").replace(/\D/g, ""); // tylko cyfry
        if (v.length > 8) v = v.slice(0, 8);

        // DDMMYYYY -> DD.MM.YYYY
        if (v.length >= 5) {
          e.target.value = `${v.slice(0, 2)}.${v.slice(2, 4)}.${v.slice(4)}`;
        } else if (v.length >= 3) {
          e.target.value = `${v.slice(0, 2)}.${v.slice(2)}`;
        } else {
          e.target.value = v;
        }
      },
      validate: (value: string) => {
        const regex =
          /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.(19|20)\d{2}$/;

        if (!regex.test(value)) return t("niepoprawny_format_daty");

        const [day, month, year] = value.split(".").map(Number);
        const date = new Date(year, month - 1, day);

        if (
          date.getFullYear() !== year ||
          date.getMonth() !== month - 1 ||
          date.getDate() !== day
        ) {
          return t("niepoprawna_data");
        }

        if (date > new Date()) return t("data_nie_moze_byc_z_przyszlosci");

        return true;
      },
    }),
  },
}
];

